export const EPI_COLORS = {
	ok: '#26a63b',
	success: '#4caf50',
	warning: '#ffa726',
	danger: '#ef5350',
	neutral: '#78909c',
	info: '#2196f3',
	purple: '#ab47bc',
	orange: '#ff7043'
};

export const EPI_CHART_AXIS_TEXT_COLOR = '#e5e5e5';

export const situationLabels: Record<string, string> = {
	INSPECIONADO: 'Inspecionado',
	VENCENDO: 'Vencendo',
	NAO_INSPECIONADO: 'Não inspecionado',
	NAO_APLICAVEL: 'Não aplicável'
};

export const situationColors: Record<string, string> = {
	INSPECIONADO: EPI_COLORS.ok,
	VENCENDO: EPI_COLORS.warning,
	NAO_INSPECIONADO: EPI_COLORS.danger,
	NAO_APLICAVEL: EPI_COLORS.neutral
};

export const complianceLabels: Record<string, string> = {
	CONFORME: 'Conforme',
	NAO_CONFORME: 'Não conforme',
	SEM_INSPECAO: 'Sem inspeção no período'
};

export const complianceColors: Record<string, string> = {
	CONFORME: EPI_COLORS.success,
	NAO_CONFORME: EPI_COLORS.danger,
	SEM_INSPECAO: EPI_COLORS.neutral
};

export const actionStatusLabels: Record<string, string> = {
	ABERTA: 'Aberta',
	EM_ANDAMENTO: 'Em andamento',
	CONCLUIDA: 'Concluída'
};

export const actionStatusColors: Record<string, string> = {
	ABERTA: EPI_COLORS.danger,
	EM_ANDAMENTO: EPI_COLORS.warning,
	CONCLUIDA: EPI_COLORS.success
};

export const resultLabels: Record<string, string> = {
	CONFORME: 'Conforme',
	NAO_CONFORME: 'Não conforme'
};

export const reasonLabels: Record<string, string> = {
	USO_INCORRETO: 'Uso incorreto',
	NAO_UTILIZAVA: 'Colaborador não estava utilizando o EPI',
	DANO: 'Dano',
	EXTRAVIO: 'Extravio',
	INADEQUACAO: 'Inadequação',
	NECESSIDADE_DE_TROCA: 'Necessidade de troca',
	OUTRO: 'Outro motivo'
};

export function reasonLabel(reason?: string, detail?: string): string {
	if (reason === 'OUTRO') {
		return detail?.trim() || reasonLabels.OUTRO;
	}
	return reasonLabels[reason || ''] || reason || '—';
}

export function companyLabel(company: { companyId: number; companyName: string }): string {
	return `${company.companyName} - ${company.companyId}`;
}

export function periodLabel(from?: string, to?: string): string {
	if (from && to) {
		return `entre ${from} e ${to}`;
	}
	if (from) {
		return `a partir de ${from}`;
	}
	return to ? `até ${to}` : '';
}
